const inputsPhoneNumber = document.querySelectorAll(".phone-number");

if (inputsPhoneNumber) {
   inputsPhoneNumber.forEach(function (input) {
      window.intlTelInput(input, {
         initialCountry: "auto",
         autoPlaceholder: "off",
         autoFormat: false,
         formatOnDisplay: false,
         geoIpLookup: callback => {
            fetch("https://ipapi.co/json")
               .then(res => res.json())
               .then(data => {
                  callback(data.country_code);
               })
               .catch(error => {
                  callback("us"); // Fallback to "us" in case of error
               });
         },
         utilsScript: "https://cdn.jsdelivr.net/npm/intl-tel-input@22.0.2/build/js/utils.js",
      });

      input.addEventListener("input", function (event) {
         const inputValue = event.target.value;

         if (inputValue.charAt(0) !== "+") {
            event.target.value = "+" + inputValue;
         }
      });

      input.addEventListener("blur", function (event) {
         const inputValue = event.target.value;
         // Remove all spaces and hyphens from the value
         event.target.value = inputValue.replace(/[\s\-]+/g, '');
      });
   });
}
